import React from 'react';
import './GetInTouch.scss';
import Button from '../Button/Button';
import {Link} from 'react-router-dom';
import {EnvelopeIcon} from '@heroicons/react/24/outline';
import { ROUTES } from '../../constants/routes';

const GetInTouch = () => {
  return (
	  <>
		<section className='get-in-touch'>
		  <Link to={ROUTES.CONTACT}>
			<Button className={'light solid'}>
			  <h3>Get in touch with us!</h3>
			  <EnvelopeIcon className={'heroicon-24'}/>
			</Button>
		  </Link>
		</section>
	  </>
  );
};

export default GetInTouch;
